module.exports = __webpack_public_path__ + "static/media/don-promise.bce24ddf.jpg";